import { z } from 'zod';

/**
 * Path to return to after a successful login, captured by the `_authenticated` guard.
 * Only internal paths pass: a single leading `/` (URL parsers resolve `//` and `/\` as
 * off-origin) with no tab/newline/CR — the WHATWG parser strips those, which would turn
 * `/\t/evil.com` into `//evil.com`.
 *
 * Shared by every auth route that carries the destination onward, so a user who is sent
 * through verification still lands where they were headed.
 */
export const loginRedirectSchema = z
  .string()
  .regex(/^\/(?![/\\])[^\t\n\r]*$/)
  .optional()
  .catch(undefined);
